import { render, staticRenderFns } from "./AppBibleNews.vue?vue&type=template&id=3a43701f&"
import script from "./AppBibleNews.vue?vue&type=script&lang=js&"
export * from "./AppBibleNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports